import { render, staticRenderFns } from "./WithdrawBalance.vue?vue&type=template&id=1acbb4f5"
import script from "./WithdrawBalance.vue?vue&type=script&lang=js"
export * from "./WithdrawBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports